export enum EventStatuses {
    Offen = 1,
    Lohnabrechnung,
    Abgeschlossen,
    Abgesagt
}

export default class EventStatus {
    id: number
    description: string
}